const BASE_TEST_API_URL = 'http://localhost:3000/api';
const BASE_API_URL = '/api';

type BaseServiceUrls =
  | '/roster'
  | '/auth'
  | '/search'
  | '/construct'
  | '/session'
  | '/fulfillment'
  | '/rosteradapter';

export type Version = '/v1' | '/v2' | '/v3';

function buildUrl(
  endpoint: `/${string}`,
  service: BaseServiceUrls = '/roster',
  version: Version = '/v2'
) {
  const base = import.meta.env.TEST ? BASE_TEST_API_URL : BASE_API_URL;
  return base + service + version + endpoint;
}

export async function fetcher<TResponse = unknown>(
  endpoint: `/${string}`,
  config?: RequestInit & { service?: BaseServiceUrls; version?: Version }
) {
  const { service, version, ...rest } = config ?? {};

  const response = await fetch(buildUrl(endpoint, service, version), {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    ...rest,
  });

  if (response.ok) {
    try {
      // await is here to not make consumers handle
      // this condition so it only has to be fixed
      // in a single location
      return (await response.json()) as TResponse;
    } catch (error) {
      // Temporary until we can properly
      // check headers for response type
      return null;
    }
  }

  throw new Error(`Response was not ok - TODO: better error handling here`);
}
